import { styled as e } from "styled-components";
//#region src/components/NotFoundView/NotFoundView.styled.ts
var t = e.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: ${({ theme: e }) => e.spacing(2)};
    /* Fills the routed area without assuming a viewport height — the shells
       already own their own chrome and scroll container. */
    min-height: 55vh;
    padding: ${({ theme: e }) => e.spacing(6, 3)};
    max-width: 460px;
    margin: 0 auto;
`, n = e.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    border-radius: ${({ theme: e }) => e.radii.full};
    background-color: ${({ theme: e }) => e.colors.muted};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    margin-bottom: ${({ theme: e }) => e.spacing(1)};
`, r = e.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    margin-top: ${({ theme: e }) => e.spacing(2)};
`;
//#endregion
export { r as Actions, n as IconChip, t as Wrapper };
